'use client'

import { cn } from '@/lib/utils'

type ProductTagsProps = {
  tags: { id: number; name: string; background_color: string; text_color: string, color: string }[]
}

export default function ProductTags({ tags }: ProductTagsProps) {
  if (tags.length === 0) return null

  const firstTag = tags[0]
  const otherTags = tags.slice(1)

  return (
    <>
      <span className="tag" style={{ backgroundColor: firstTag.color }}>{firstTag.name}</span>
      {otherTags.length > 0 && (
        <div className="absolute top-1 right-1 flex flex-col items-end z-10">
          {otherTags.map((tag) => (
            <span
              key={tag.id}
              className={cn('text-[11px] px-1 rounded mb-1 w-max')}
              style={{ backgroundColor: `${tag.color}`, color:  "#FFFFFF"}}
            >
              {tag.name}
            </span>
          ))}
        </div>
      )}
    </>
  )
}
